import { reduxForm } from 'redux-form';
import Component from './ResetPassword';
import validate from './validate';

const initialValues = {
  password: '',
  repeatPassword: '',
  token: '',
};

export default reduxForm({
  form: 'resetPassword',
  initialValues,
  validate,
})(Component);
